function parseFontWeight(weight) {
  return `${weight}`;
}

export { parseFontWeight };
//# sourceMappingURL=parseFontWeight.mjs.map
